import {
  AVAILABLE_APPOINTMENT_STATUSES,
  EnhancedAppointment,
} from '@bb/domain/dist/types';
import { Button, ButtonProps, Icon, Spin, theme } from 'components';
import React from 'react';
import styled from 'styled-components';
import { covidNeedsAction } from '../../utils';

export type Covid19ActionsEntryProps = Pick<
  EnhancedAppointment,
  | 'covid19RequestedAck'
  | 'covid19Overridden'
  | 'covid19Signed'
  | 'status'
  | 'timeEnd'
> & {
  isBuyer: boolean;
  signatureType: 'template' | 'pdf';
  onSignPrompt: () => void;
  onSignatureView: () => void;
  isMobile?: boolean;
  loading?: boolean;
};

const DEFAULT_ICON_PROPS = {
  width: 12,
  height: 12,
};

const Covid19ActionsEntry: React.FC<Covid19ActionsEntryProps> = ({
  isBuyer,
  covid19RequestedAck,
  covid19Overridden,
  covid19Signed,
  signatureType,
  status,
  timeEnd,
  onSignPrompt,
  onSignatureView,
  isMobile,
  loading,
}) => {
  if (!AVAILABLE_APPOINTMENT_STATUSES.includes(status)) return null;

  let text;
  let BtnComponent = Button;
  const btnProps: ButtonProps = {
    type: 'link',
    size: 'small',
    underlineOnHover: true,
  };

  if (
    covidNeedsAction({
      covid19Overridden,
      covid19RequestedAck,
      covid19Signed,
      status,
      timeEnd,
    })
  ) {
    btnProps.onClick = e => {
      e.stopPropagation();
      onSignPrompt();
    };
    if (isBuyer) {
      text = 'Sign COVID-19 Form';
    } else {
      text = 'COVID-19 not signed';
      BtnComponent = StyledCovidNotSignedButton;
      btnProps.icon = (
        <Icon
          type="antdWarningFilled"
          {...DEFAULT_ICON_PROPS}
          offset={[0, -2]}
          color="danger"
        />
      );
    }
  } else if (covid19Overridden) {
    text = 'COVID-19 overridden';
    btnProps.icon = (
      <Icon
        type="check"
        {...DEFAULT_ICON_PROPS}
        offset={[0, 0]}
        color="grayBase"
      />
    );
    btnProps.underlineOnHover = false;
    btnProps.disabled = true;
  } else if (covid19Signed) {
    text = `COVID-19 ${signatureType === 'template' ? 'signed' : 'uploaded'}`;
    btnProps.onClick = e => {
      e.stopPropagation();
      onSignatureView();
    };
    btnProps.icon = loading ? (
      <Spin spinning size="small" />
    ) : (
      <Icon
        type="check"
        {...DEFAULT_ICON_PROPS}
        offset={[0, -1]}
        color="primary"
      />
    );
  } else {
    return null;
  }

  if (isMobile) btnProps.style = { ...btnProps.style, margin: 0, padding: 0 };

  return (
    <BtnComponent {...btnProps} data-cy="showing-covid-button">
      {text}
    </BtnComponent>
  );
};

const StyledCovidNotSignedButton = styled(Button)`
  color: ${theme.btnDefaultColor};
  transition: color 0.4s;
`;

export default Covid19ActionsEntry;
